/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindOrganizationDto } from './FindOrganizationDto';
import {
    FindOrganizationDtoFromJSON,
    FindOrganizationDtoFromJSONTyped,
    FindOrganizationDtoToJSON,
    FindOrganizationDtoToJSONTyped,
} from './FindOrganizationDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListOrganizationsResponseDto
 */
export interface ListOrganizationsResponseDto {
    /**
     * 
     * @type {Array<FindOrganizationDto>}
     * @memberof ListOrganizationsResponseDto
     */
    data: Array<FindOrganizationDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListOrganizationsResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListOrganizationsResponseDto interface.
 */
export function instanceOfListOrganizationsResponseDto(value: object): value is ListOrganizationsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListOrganizationsResponseDtoFromJSON(json: any): ListOrganizationsResponseDto {
    return ListOrganizationsResponseDtoFromJSONTyped(json, false);
}

export function ListOrganizationsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListOrganizationsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(FindOrganizationDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListOrganizationsResponseDtoToJSON(json: any): ListOrganizationsResponseDto {
    return ListOrganizationsResponseDtoToJSONTyped(json, false);
}

export function ListOrganizationsResponseDtoToJSONTyped(value?: ListOrganizationsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(FindOrganizationDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

